import { IChangePasswordModal } from '../interfaces';

export const ChangePasswordInitialstates: IChangePasswordModal = {
  isLoading: false,
  isError: false,
};
